<template>
  <div>
    <div class="modal fade in show modal-active modal-open" id="deleteRecipientModal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Delete recipient</h4>
            <button type="button" class="close" v-on:click="closeModal()">&times;</button>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row">
              <div class="col-3">
                Recipient name
              </div>
              <div class="col-3">
                Recipient email
              </div>
              <div class="col-3">
                Recipient phone
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                {{delRecipient.name}}
              </div>
              <div class="col-3">
                {{delRecipient.email}}
              </div>
              <div class="col-3">
                {{delRecipient.phone}}
              </div>
            </div>
          </div><!-- Modal body end -->
          <div class="modal-footer mt-2">
            <button type="button" class="btn btn-lg btn-outline-primary mt-2" v-on:click="closeModal()">Cancel</button>
            <button type="button" class="btn btn-lg btn-primary mt-2" v-on:click="deleteRecipient()">Delete recipient</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop show"></div>
  </div>  
</template>

<script>
export default {
  name: "DeleteRecipientModal",
  props: [
    'delRecipient'
  ],
  data(){
    return {
    }
  },
  methods: {
    closeModal(){
      this.$emit('closeDeleteRecipientModal');
    },
    deleteRecipient(){
      this.$emit('deleteRecipient');
    }
  }
}
</script>